import HeaderComponent from "../../components/header/index";
import { useDispatch, useSelector } from "react-redux";
import {
  EndPointUserDetails,
  LOGIN_SSO_URL,
  RN_SENDOTP_API,
} from "../../services/common/endpoints";

import { Link, useLocation, useNavigate } from "react-router-dom";

import { useMutation, useQuery } from "react-query";
import { useEffect, useState } from "react";
import { callQueryapi } from "../../services/http/callapi";
import Loadingcomponent from "./../../components/loader/loadingcomponent";
import BottomModalComponent from "./../../components/common/bottom-modal";
import {
  GetCacheKey,
  loginencrypt,
  setItem,
  getItem,
  getItemOfSessionStorage,
} from "../../services/common/utils";
import {
  setcustomerprofile,
  setrnuserdetails,
  setSelectedNumber,
  settoken,
  setLoginType,
  setRatePlanType,
  setGTMLoginFlag, 
  setSocialLoginType,
  setISB2BCPRNumber,
  setUserLoggedInNumber
} from "../../reducer/actions";
import { TOKEN_ID } from "../../services/common/Constants";
import { useTranslation } from "react-i18next";
import {
  RecordScreenEvent,
  RecordlogEvents,
  setRecordUserProperty,
} from "../../../src/analytics/RecordEvents";
import { getPaymentResponsibleValue, isB2BCPRNumber } from "../../services/common/CommonUtils";
import { LOGIN_TYPE, SELECTED_LANG } from "../../services/common/Constants";
import {
    LoginSocialGoogle,
    LoginSocialFacebook,
  } from "reactjs-social-login";
import AppleLogin from "react-apple-login";
import jwt_decode from "jwt-decode";
import {GTMScreenView, GTM_Login} from "../../../src/analytics/GoogleTagManager";
import { setItemInSessionStorage } from "../../services/common/utils";

const LoginVerification = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const tokenid = useSelector((state) => state?.userdata?.value?.tokenid);
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const userdata = useSelector(
    (state) => state?.userdata?.value?.rnuserdetails
  );
  let [loginid, setloginid] = useState("");
  const [loginidreadonly, setLoginidReadonly] = useState(false);
  const [pwd, setpwd] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const [showerrorpopup, setShowErrorPoup] = useState("");
  const [resperrorMessage, setresperrorMessage] = useState("");
  const [isEmailCase, setIsEmailCase] = useState(false);
  const [timer, setTimer] = useState("0:00s");
  const [enableotpapi, setenableotpapi] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [error, setError] = useState(null);
  const [apiMessage, setApiMessage] = useState("");
  const [eyeIcon, setEyeIcon] = useState("password");
  let _loginMode = "";
  const [pwdDisabledButton, setPwdDisabledButton] = useState(false);
  const loginmsisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  const socialMediaType = useSelector((state) => state?.userdata?.value?.socialMediaType);
  const[socialType,setsocialtype] = useState("");
  const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  const toggleerrorbottomModal = () => {
    setShowErrorPoup(!showerrorpopup);
  };

  const otpLogin = useMutation(
    (req) =>
      callQueryapi({
        queryKey: [{}, RN_SENDOTP_API, req],
      }),
    {
      onSuccess: async (udata, variables, context) => {
        try {
          // console.log("xxxxxxxx", udata);
          if (udata?.data != null && udata?.data?.status == "0") {
            const transId = udata?.data?.response?.transid;
            // console.log(toggleModal())
            try {
              global.logintype = "otp";
              dispatch(setLoginType("otp"));
            } catch (e) {}
              navigate("/otp-login", {
                state: {
                  msisdn: loginid,
                  transId: transId,
                  email: loginid,
                  epd: true,
                  loginmode: location?.state?.loginmode,
                  rnRegisteredData: location?.state?.rnRegisteredData,
                  message: udata?.data?.message
                },
              });              
          } else if (udata?.data?.status == "-1") {
            setDisabledButton(false);
            setShowErrorPoup(true);
            setresperrorMessage(udata?.data?.message);
          } else {
            setDisabledButton(false);
          }
        } catch (e) {
          setDisabledButton(false);
          console.log(e);
        }
      },
      onError: (uerror, variables, context) => {
        // console.log("sendotp onerror");
        setDisabledButton(false);
      },
    }
  );

  let sendOtpReqObj = {};

  if (location?.state?.loginmode === "msisdn") {
    sendOtpReqObj.type = "sms";
    sendOtpReqObj.msisdn = `965${loginid}`;
    sendOtpReqObj.action = "auth";
  } else {
    sendOtpReqObj.type = "email";
    sendOtpReqObj.email = loginid;
    sendOtpReqObj.action = "forgotpwd";
  }

  const sendotp = useQuery(["", "/v6/api/sso/rnsendotp", sendOtpReqObj, {}], {
    retry: false,
    retryOnMount: false,
    enabled: false,
    onSuccess: (res) => {
      if (res?.data?.status == "0") {
        if (res?.data?.response) {
          const _transId = res?.data?.response?.transid;
          navigate("/email-verification?headerText=one_time_password", {
            state: {
              emailId: loginid,
              transId: _transId,
              loginmode: location?.state?.loginmode || "",
            },
          });
        } else {
          setApiMessage(res?.data?.message);
          return false;
        }
      } else {
        setApiMessage(res?.data?.message);
        return false;
      }
    },
    onerror: (err) => {
      if (err?.data?.message) setApiMessage(err?.data?.message);
      else if (err?.message) setApiMessage(err?.message);
      else setApiMessage(t("somethingwentwrong"));
      return false;
    },
  });

  const rnuserdetails = useQuery(
    [
      GetCacheKey("GET_RN_USER_DETAILS"),
      EndPointUserDetails.url,
      EndPointUserDetails.data,
      {},
    ],
    {
      retry: false,
      retryOnMount: true,
      enabled: loggedIn,
    }
  );
  let isvalidEmail = false;
  const userDetailsApi = useQuery(
    [
      GetCacheKey("GET_USER_DETAILS"),
      "customerprofile/get",
      { source: "homepage", sec: "splash" },
      {},
    ],
    {
      retry: false,
      retryOnMount: true,
      enabled: loggedIn,
    }
  );
  useEffect(() => {
    try {
      RecordScreenEvent("Login", logintype, userdata);
      global.userlanguage = getItemOfSessionStorage(SELECTED_LANG);
    } catch (e) {}
    try{
      GTMScreenView("Login", location?.state?.loginmode==="msisdn" ? location?.state?.loginid : "", logintype)
    }catch{}
  }, []);


  useEffect(() => {
    try {
      // console.log("loginid prev screen:" + location?.state?.loginid);
      if (location?.state?.loginid) {
        setLoginidReadonly(true);
        setloginid(location.state.loginid);
        try {
          if (
            location?.state?.loginmode &&
            location?.state?.loginmode == "email"
          ) {
            setIsEmailCase(true);
          }
        } catch (e) {}
      }
    } catch (e) {}
  }, [location]);
  useEffect(() => {
    if (userDetailsApi.isSuccess && userDetailsApi?.data?.data) {
      dispatch(setcustomerprofile(userDetailsApi?.data?.data?.response));
      setItemInSessionStorage("Customerid",userDetailsApi?.data?.data?.response?.CustomerID)
      try{
        var _isB2BCpr = isB2BCPRNumber(userDetailsApi?.data?.data?.response);
        dispatch(setISB2BCPRNumber(_isB2BCpr));
      }catch{}
    }
    if (rnuserdetails.isSuccess && rnuserdetails?.data?.data) {
      dispatch(setrnuserdetails(rnuserdetails?.data?.data?.response));
      try {
        let _msisdn = "";
        if (rnuserdetails?.data?.data?.response?.msisdn && rnuserdetails?.data?.data?.response?.msisdn.length == 11)
          _msisdn = rnuserdetails?.data?.data?.response?.msisdn.slice(3);
        else
          _msisdn = rnuserdetails?.data?.data?.response?.msisdn
          try{
          if(_msisdn == null || _msisdn == undefined || _msisdn == "" || _msisdn == "undefined"){
            if (userDetailsApi?.data?.data?.response?.Msisdn && userDetailsApi?.data?.data?.response?.Msisdn.length == 11)
            _msisdn = userDetailsApi?.data?.data?.response?.Msisdn.slice(3);
          else
            _msisdn = userDetailsApi?.data?.data?.response?.Msisdn
          }
        }catch{}
        dispatch(setSelectedNumber(_msisdn));
        dispatch(setUserLoggedInNumber(_msisdn));
      } catch (e) { }
    }
    if (rnuserdetails?.isSuccess && userDetailsApi?.isSuccess) {
      try {
        global.userdetails = rnuserdetails?.data?.data?.response;
        global.rateplantype = userDetailsApi?.data?.data?.response.RatePlanType;
        //console.log("global.userdetails:"+JSON.stringify(global.userdetails)+"")
        try {
          dispatch(
            setRatePlanType(userDetailsApi?.data?.data?.response?.RatePlanType)
          );
        } catch {}
      } catch (e) {}
      try {
        setPropertyCT(userDetailsApi?.data?.data);
        loginEventCT(userDetailsApi?.data?.data);
      } catch (e) {}
      try{
          let type_login = socialType == "" ? logintype : "social" 
          dispatch(setSocialLoginType(socialType));
          dispatch(setLoginType(type_login))
          dispatch(setGTMLoginFlag(true));
        // let type_login = socialType == "" ? logintype : "social" 
        // GTM_Login("Login", location?.state?.loginmode==="msisdn" ? location?.state?.loginid : "", type_login, socialType);
      }catch{}
      navigate("/home/index");
    }
  }, [
    userDetailsApi?.data?.data,
    userDetailsApi.isSuccess,
    rnuserdetails?.data?.data,
    rnuserdetails.isSuccess,
  ]);
  // console.log("-----tokenid", tokenid);
  const { mutate, isLoading, isFetching } = useMutation(
    (req) =>
      callQueryapi({
        queryKey: [{}, LOGIN_SSO_URL, req],
      }),
    {
      onSuccess: async (udata, variables, context) => {
        try {
          //console.log("-----Response", udata);
          setItemInSessionStorage("loginStatus", udata.data.message)
          if (
            udata != null &&
            udata.data != null &&
            udata.data.response != null &&
            udata.data.response.tokenid != null
          ) {
            try{
              let _l = loginid;
              if(_loginMode == "msisdn" && _l?.length == 11)
                  _l = _l.slice(3);
              localStorage.setItem("sl",_l)
             }catch{}
            try {
              dispatch(setLoginType(_loginMode));
              if(_loginMode === "msisdn"){ 
                dispatch(setSelectedNumber(msisdn)) 
                dispatch(setUserLoggedInNumber(msisdn));
              }
            } catch {}
            dispatch(settoken(udata.data.response.tokenid));
            setItem(TOKEN_ID, udata.data.response.tokenid);
            setLoggedIn(true);
          } else {
            try {
              setpwd('')
              setShowErrorPoup(true);
              if (udata?.message) setresperrorMessage(udata?.message);
              else if (udata?.data?.message)
                setresperrorMessage(udata?.data?.message);
              else setresperrorMessage(t("somethingwentwrong"));
              try{
                  let type_login = socialType == "" ? logintype : "social" 
                  dispatch(setLoginType(type_login))
                  dispatch(setGTMLoginFlag(true));
              }catch{}
              // let type_login = socialType == "" ? logintype : socialType 
              // GTM_Login("Login", location?.state?.loginmode==="msisdn" ? location?.state?.loginid : "", type_login, socialType);
            } catch (e) {}
          }
        } catch (e) {}
      },
      onError: (uerror, variables, context) => {
        //console.log("-----_Error");
        try {
          setShowErrorPoup(true);
          if (uerror?.message) setresperrorMessage(uerror?.message);
          else if (uerror?.data?.message)
            setresperrorMessage(uerror?.data?.message);
          else setresperrorMessage(t("somethingwentwrong"));
        } catch (e) {}
      },
    }
  );

  const validateEmail = (enteredValue) => {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(enteredValue)) {
      isvalidEmail = false;
    } else {
      isvalidEmail = true;
    }
    return isvalidEmail;
  };

  const LoginUser = () => {
    _loginMode = "email";

    if (loginid == null || loginid == "" || loginid == undefined) {
      setShowErrorPoup(true);
      setresperrorMessage(t("pevme"));
      return false;
    }
    if (loginid?.length == 8) {
      loginid = "965" + loginid;
      global.logintype = "msisdn";
      _loginMode = "msisdn";
    } else {
      if (validateEmail(loginid)) {
        // console.log("email is valid");
      } else {
        // console.log("email is not valid");
        setShowErrorPoup(true);
        setresperrorMessage(t("yedlr"));
        return false;
      }
      _loginMode = "email";
      global.logintype = "email";
    }

    if (pwd == null || pwd == "" || pwd == undefined) {
      setShowErrorPoup(true);
      setresperrorMessage(t("pepwd"));
      return false;
    }

    try {
      let encPwd = loginencrypt(pwd);
      let params = {
        loginid: loginid,
        loginmode: _loginMode,
        pwd: encPwd,
        socialid: "",
        RM: "1",
      };
      mutate(params);
    } catch (e) {
      //console.log(e);
    }
  };
  const otpclick = () => {
    navigate("otp");
  };

  const otpLoginApi = () => {
    try {
      setDisabledButton(true);
      var _msisdnwithCountrycode = "";
      if (loginid?.length == 8) {
        // console.log("success");
        _msisdnwithCountrycode = "965" + loginid;
      }
      let parametrs = {};
      if (!isNaN(loginid)) {
        parametrs = {
          type: "sms",
          msisdn: _msisdnwithCountrycode,
          action: "auth",
        };
      } else {
        parametrs = { type: "email", action: "auth", email: loginid };
      }
      setenableotpapi(true);
      otpLogin.mutate(parametrs);
    } catch (e) {
      setDisabledButton(false);
    }
  };

  const passwordLoginApi = () => {
    try {
      setPwdDisabledButton(true);
      var _msisdnwithCountrycode = "";
      if (loginid?.length == 8) {
        // console.log("success");
        _msisdnwithCountrycode = "965" + loginid;
      }
      navigate("/otp-login", {
        state: {
          msisdn: loginid,
          transId: "",
          email: loginid,
          epd: false,
          rnRegisteredData: location?.state?.rnRegisteredData,
          loginmode: location?.state?.loginmode,
        },
      });

    } catch (e) {
      setDisabledButton(false);
    }
  };

  // if (
  //   isLoading ||
  //   isFetching ||
  //   rnuserdetails.isLoading ||
  //   userDetailsApi.isLoading ||
  //   rnuserdetails.isFetching ||
  //   userDetailsApi.isFetching ||
  //   // otpLogin.isLoading ||
  //   // otpLogin.isFetching ||
  //   sendotp?.isLoading
  // ) {
  //   return <Loadingcomponent message={"Loading"} />;
  // }

  const isApiLoading = (isLoading ||
  isFetching ||
  rnuserdetails.isLoading ||
  userDetailsApi.isLoading ||
  rnuserdetails.isFetching ||
  userDetailsApi.isFetching ||
  sendotp?.isLoading || sendotp.isFetching)

  const sendOtpApiCalling = (sendotp?.isLoading || sendotp.isFetching);

  const setPropertyCT = (data_sp) => {
    try {
      setRecordUserProperty({
        email: userdata?.email || "",
        name: userdata?.firstname,
        ContractID: data_sp?.response.ContractID,
        mobileNo: data_sp?.response.Msisdn,
        isdigital: data_sp?.response.IsDigitalCustomer,
        rateplantype: data_sp?.response.RatePlanType,
        custtype: data_sp?.response.Segment,
        language: getItemOfSessionStorage(SELECTED_LANG),
        voiceline: data_sp?.response.voiceline,
        rnuserdetails: userdata,
      });
    } catch (e) {}
  };

  const loginEventCT = (data_lg) => {
    global.loginEventCalled = "yes";
    try {
      // getItem(LOGIN_TYPE).then(val => {
      //   var logintype = '';
      //   if (val === 'otp') {
      //     logintype = 'otp';
      //     global.logintype = 'otp';
      //   } else if (val === 'he') {
      //     logintype = 'HE';
      //     global.logintype = 'HE';
      //   } else if (val === 'Facebook') {
      //     logintype = 'Facebook';
      //     global.logintype = 'Facebook';
      //   } else if (val === 'gmail') {
      //     logintype = 'gmail';
      //     global.logintype = 'gmail';
      //   } else if (val === 'appleid') {
      //     logintype = 'appleid';
      //     global.logintype = 'appleid';
      //   } else if (val === 'email' || val === 'pass') {
      //     logintype = 'email';
      //     global.logintype = 'email';
      //   } else {
      //     logintype = val;
      //     global.logintype = val;
      //   }
      // });

      RecordlogEvents("Login", {
        SSO:
          userdata === "" ||
          userdata === null ||
          userdata === "NULL" ||
          userdata === "null" ||
          userdata === undefined
            ? userdata?.msisdn
            : userdata?.email,
        "Login Type": logintype,
        IsDigital: data_lg?.response?.IsDigitalCustomer,
        PaymentResponsible: getPaymentResponsibleValue(data_lg?.response),
        RatePlanType: data_lg?.response?.RatePlanType,
        "Customer Type": data_lg?.response?.CustomerType,
        "Mobile Number": data_lg?.response?.Msisdn,
        language: getItemOfSessionStorage(SELECTED_LANG),
        status: "Success",
        "Status Description":
          data_lg.message != null && data_lg.message !== ""
            ? data_lg.message
            : data_lg.actualmessage,
      });
    } catch (e) {}
  };
  
  const eyeiconclick = () => {
    if(pwd?.length > 0){
      if (eyeIcon == "password") {
        setEyeIcon("text");
      } else {
        setEyeIcon("password");
      }
    }
  };
// console.log(sendotp, "sendotp?.data?.data?.response?.transid")
  const crrdata = {
    emailId: loginid,
    transId: sendotp?.data?.data?.response?.transid,
  };
  const validateOtp = () => {
    sendotp.refetch();
  };
  const onKeyPress = (e) => {
    if (e.which === 13) {
      LoginUser();
    }
  };
  return (
    <div>
      {/* Gets startted Component */}
      {/* <HeaderComponent></HeaderComponent>
        <section className="app_main_wrapper d-flex flex-column ">
            <div className="bottom_bg_section">
                <div className="bottom_bg_section_container">
                    <img src={bgImg} alt="" title="" />
                </div>
            </div>
            <div className="center_section">
                <div className="sec_top mt-160">
                    <div className="pse_lg">
                        <button className="social_btn apple_btn mb-3">
                            <img src={appleIcon} alt="" title="" />
                            Continue with Apple
                        </button>
                        <button className="social_btn gmail_btn mb-3">
                            <img src={gmailIcon} alt="" title="" />
                            Continue with Google
                        </button>
                        <button className="social_btn facebook_btn">
                            <img src={facebookIcon} alt="" title="" />
                            Continue with Facebook
                        </button>
                        <div className="or_sepatator mt-30 mb-4">
                            <span></span>
                            <p className="mb-0">OR</p>
                            <span></span>
                        </div>
                        <div className="form-group">
                            <label className="control-label">MOBILE NUMBER / EMAIL ADDRESS</label>
                            <input type="text" maxLength={20} classNameName="form-control" placeholder="" />
                        </div>
                        <button className="custom_btn custom_btn_primary btn_block mt-20">Continue</button>
                    </div>
                </div>
                <div className="sec_btm">
                    <div className="flex_grp_center mb-30 mt-4">
                        <p className="mb-0 pe-2">Don't have an account?</p>
                        <a className="hyperlink">SIGN UP</a>
                    </div>
                </div>
            </div>
        </section> */}

      <HeaderComponent type={1}></HeaderComponent>

      <section className="app_main_wrapper pt-70 pb-76 d-flex flex-column">
        <div className="bottom_bg_section">
          <div className="bottom_bg_section_container">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/assets_bg.jpg"}
              alt=""
              title=""
            />
          </div>
        </div>
        <div className="center_section">
          <div className="sec_top mt-160">
            <div className="pse_lg">
              <div className="form-group text-start mb-4">
                <label className="control-label">{t("mnea")}</label>
                <input
                  type="text"
                  readOnly={loginidreadonly}
                  value={loginid}
                  onKeyDown={(e) => onKeyPress(e)}
                  onChange={(e) => {
                    setloginid(e.target.value);
                  }}
                  maxLength={50}
                  className="form-control"
                  placeholder=""
                />
              </div>
                        
            {/* pass word login */}
            {location?.state?.rnRegisteredData?.epd === "T" && location?.state?.rnRegisteredData?.sfa !== "T" && location?.state?.rnRegisteredData?.sga !== "T" && location?.state?.rnRegisteredData?.saa !== "T" &&(
              <div>
                  <div className="form-group text-start">
                  <label className="control-label">{t("password")}</label>
                  <div className="input_icon right-icon">
                      <input
                      onChange={(e) => {
                          setpwd(e.target.value);
                      }}
                      onKeyDown={(e) => onKeyPress(e)}
                      type={eyeIcon}
                      maxLength={20}
                      className="form-control"
                      placeholder=""
                      />
                      <button onClick={() => eyeiconclick()}>
                      <img
                          src={
                          eyeIcon == "password"
                              ? process.env.PUBLIC_URL +
                              "/assets/images/password_hide_dark.svg"
                              : process.env.PUBLIC_URL +
                              "/assets/images/password_show_dark.svg"
                          }
                          alt=""
                          title=""
                      />
                      </button>
                  </div>
                  </div>

                  <div className="flex_grp_end mt-3">
                  <div
                      onClick={() => {
                      validateOtp();
                      }}
                      className="hyperlink hyperlink_sm"
                  >
                      {t("forgotpassword")}
                  </div>
                  </div>
              </div>
            )}
          
            {/* socila message */}
            {(location?.state?.rnRegisteredData?.sga === "T" ||  location?.state?.rnRegisteredData?.sfa === "T"  || location?.state?.rnRegisteredData?.saa === "T") &&
                  <div className="support_text mb-0"><p>{t("socialMessage")}</p></div>
            }

            <div className="center_section">
              {/* login with google account */}
              {location?.state?.rnRegisteredData?.sga === "T" &&(
                  <LoginSocialGoogle
                      client_id={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                      scope='email profile'
                      onResolve={(resGoogle) => {
                      console.log("resGoogle", resGoogle);

                      const requestData = {
                          loginid: resGoogle?.data?.email,
                          loginmode: "email",
                          socialmediatype: "gmail",
                          pwd: "",
                          socialid: resGoogle?.data?.sub,
                          RM: "1",
                      };
                      setsocialtype("gmail");
                      // console.log('requestData', requestData);
                      mutate(requestData);
                      //   socialSignIn.mutate(requestData);
                      }}
                      onReject={(err) => {
                      console.log("err", err);
                      }}
                  >
                      <button className="social_btn gmail_btn mb-3">
                      <img
                          src={process.env.PUBLIC_URL + "/assets/images/gmail.png"}
                          alt=""
                          title=""
                      />
                      {t("cwg")}
                      </button>
                  </LoginSocialGoogle>
              )}

              {/* login with facebook account */}
              {location?.state?.rnRegisteredData?.sfa === "T" &&(
                <LoginSocialFacebook
                    appId={process.env.REACT_APP_FB_APP_ID}
                    onResolve={(resolveRes) => {
                        console.log("resolveRes", resolveRes);

                        const requestData = {
                        loginid: resolveRes?.data?.email,
                        loginmode: "email",
                        socialmediatype: "Facebook",
                        pwd: "",
                        socialid: resolveRes?.data?.userID,
                        RM: "1",
                        };
                        setsocialtype("Facebook");
                        mutate(requestData);
                    }}
                    onReject={(rejectRes) => {
                        console.log("rejectRes", rejectRes);
                    }}
                    >
                    <button className="social_btn facebook_btn">
                        <img
                        src={
                            process.env.PUBLIC_URL + "/assets/images/facebook.svg"
                        }
                        alt=""
                        title=""
                        />
                        {t("cwf")}
                    </button>
                </LoginSocialFacebook>
              )}

              {/* login with apple account */}
              {location?.state?.rnRegisteredData?.saa === "T" &&(
                <AppleLogin
                    clientId={process.env.REACT_APP_APPLE_CLIENT_ID}
                    redirectURI={process.env.REACT_APP_APPLE_REDIRECT_URI}
                    scope="name email"
                    usePopup={true}
                    callback={(resAppleLogin) => {
                        // console.log('resAppleLogin', resAppleLogin);
                        const token = resAppleLogin?.authorization?.id_token || "";
                        // const token = 'eyJraWQiOiJZdXlYb1kiLCJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwcGxlaWQuYXBwbGUuY29tIiwiYXVkIjoiY29tLm9vcmVkb28ubXlhY2NvdW50d2ViIiwiZXhwIjoxNjczNDQzMDI3LCJpYXQiOjE2NzMzNTY2MjcsInN1YiI6IjAwMDQ1NC5lYmE5OWVkYzUzMjk0YzExYmVjODU3Mzk3NGE2YjA1MC4wNzUyIiwiY19oYXNoIjoiMXNMYnAzUHJ0UXpaakxldVVFb2lqZyIsImVtYWlsIjoiMjUyZjVxZDY5a0Bwcml2YXRlcmVsYXkuYXBwbGVpZC5jb20iLCJlbWFpbF92ZXJpZmllZCI6InRydWUiLCJpc19wcml2YXRlX2VtYWlsIjoidHJ1ZSIsImF1dGhfdGltZSI6MTY3MzM1NjYyNywibm9uY2Vfc3VwcG9ydGVkIjp0cnVlfQ.tCkVLBo7EPP0hlzeRwnSFDqxJFrnrRrHkFxL4lsB5sIw2gPeNinj1tcXgBi0MqzCY0mDhUfMZPcnbOu-vsnAjFQY3nkYS17qiRpqw8wePmUMsFrhGJmZjA8YFKBTd1s5_nPWGWM6izRupkjeScyU3Z5GFjaduvChuFi1smWGoEi6mlC1_lhOwU_eQVHc5aLH6Qo6D4khg_UFj5D2_LtK8cM_fThDOUMdl4H4avV3uD7DNB5FnTUt1Fw4o-PwaZICQ41fDkNBkFMwRojIE-82TWqvLJXPWai09AV8mRgbgxQniOaMlhLYfaeA4T40aGFOm1BfSFOh_R3zQ-uzuO9Jpg'
                        // console.log('token', token);
                        // const decodedHeader = jwt_decode(res?.authorization?.id_token, { header: true });
                        const decodedToken = jwt_decode(token);
                        // console.log('decodedToken', decodedToken);
                        if (!resAppleLogin?.error) {
                        const requestData = {
                            loginid: decodedToken?.email || "",
                            loginmode: "email",
                            socialmediatype: "appleid",
                            pwd: "",
                            socialid: decodedToken?.sub || "",
                            RM: "1",
                        };
                        setsocialtype("appleid");
                        mutate(requestData);
                        }
                    }}
                    render={(renderProps) => {
                      return (
                      <button
                          className="social_btn apple_btn mt-2"
                          onClick={() => renderProps?.onClick()}
                      >
                          <img
                          src={
                              process.env.PUBLIC_URL + "/assets/images/apple.svg"
                          }
                          alt=""
                          title=""
                          />
                          {t("cwa")}
                      </button>
                      );
                    }}
                />
              )}
          </div>
           
              {!isEmailCase && (
                <div>
                  <div className="or_sepatator mt-30 mb-4">
                    <span></span>
                    <p className="mb-0">{t("or")}</p>
                    <span></span>
                  </div>
                  {/* <button
      className="custom_btn custom_btn_primary_outline btn_block mt-20 mb-4"
      data-bs-toggle="modal"
      data-bs-target=".popup2"
      onClick={() => {
        otpclick();
      }}
    >
      {" "}
      USE ONE-TIME PASSWORD
    </button> */}
                  {(location?.state?.rnRegisteredData?.sfa === "T" || location?.state?.rnRegisteredData?.sga === "T" || location?.state?.rnRegisteredData?.saa === "T") && (location?.state?.rnRegisteredData?.epd === "T") &&
                    <button
                      disabled={pwdDisabledButton}
                      className="custom_btn custom_btn_primary_outline btn_block mt-20 mb-4"
                      data-bs-toggle="modal"
                      data-bs-target=".popup2"
                      onClick={() => passwordLoginApi()}
                    >
                      {" "}
                      {t("enterpwd")}
                    </button> 
                  } 

                  <button
                    disabled={disabledButton || sendOtpApiCalling}
                    className={`custom_btn custom_btn_primary_outline btn_block mt-20 mb-4 ${(disabledButton || sendOtpApiCalling) ? 'disabled_border' : ''}`}
                    data-bs-toggle="modal"
                    data-bs-target=".popup2"
                    onClick={() => otpLoginApi()}
                  >
                    {" "}
                    {t("otp")}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    { (location?.state?.rnRegisteredData?.sfa !== "T" && location?.state?.rnRegisteredData?.sga !== "T" && location?.state?.rnRegisteredData?.saa !== "T") &&
      <section className="fixed_footer">
        <div className="fixed_footer_container">
          <button
            // className={otpLogin?.isLoading ? "custom_btn custom_btn_secondary btn_block" : "custom_btn custom_btn_primary btn_block "}
            className='custom_btn custom_btn_primary btn_block'
            onClick={() => {
              LoginUser();
            }}
            disabled={otpLogin.isLoading || isApiLoading}
          >
            {(otpLogin.isLoading || isApiLoading) ? <Loadingcomponent message={"Loading"} /> : t("continue")}
          </button>
        </div>
      </section>
    }

      <BottomModalComponent
        show={showerrorpopup}
        togglebottomModal={toggleerrorbottomModal}
        respmessage={resperrorMessage}
        popuptype={"fail"}
        shouldEnableBackdropClick={true}
      />
    </div>
  );
};
export default LoginVerification;